import { useTranslation } from "react-i18next";
import { Dialog } from '@headlessui/react'
import { Bars3Icon, XMarkIcon, ChevronDownIcon } from '@heroicons/react/24/outline'
import React, { useEffect, useState } from "react";
import heroBackgroundImageDark from "../assets/images/hero_background/about_hero_bg_original4.jpg";
import heroBackgroundImageLight from "../assets/images/hero_background/home_hero_6.jpg";
import { useLocation } from "react-router-dom";

const Navbar = () => {

    const location = useLocation(); // 获取当前location
    const [currentPath, setCurrentPath] = useState(location.pathname);
    const [isLightBg, setIsLightBg] = useState(currentPath === '/');

    useEffect(() => {
        setCurrentPath(location.pathname); // 更新currentPath
        setIsLightBg(location.pathname === '/');
        // console.log("location.pathname:", location.pathname, " isLightBg: ", location.pathname === '/');
    }, [location.pathname]); // 当location.pathname变化时触发

    const lngs = {
        en: { nativeName: 'English' },
        zh: { nativeName: 'Chinese' }
    }
    const { t, i18n } = useTranslation(['navbar', 'common'])
    const isChinese = i18n.language.includes('zh');
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
    const [ethicsDropdownOpen, setEthicsDropdownOpen] = useState(false)
    const [mobileEthicsExpanded, setMobileEthicsExpanded] = useState(false)
    const dropdownTimeoutRef = React.useRef(null)

    const handleMouseEnter = () => {
        if (dropdownTimeoutRef.current) {
            clearTimeout(dropdownTimeoutRef.current)
        }
        setEthicsDropdownOpen(true)
    }

    const handleMouseLeave = () => {
        dropdownTimeoutRef.current = setTimeout(() => {
            setEthicsDropdownOpen(false)
        }, 150)
    }

    React.useEffect(() => {
        return () => {
            if (dropdownTimeoutRef.current) {
                clearTimeout(dropdownTimeoutRef.current)
            }
        }
    }, [])

    const navigation = [
        { name: t("home"), href: '/' },
        { name: t("research_highlights"), href: '/research-highlights' },
        { name: t("bench"), href: 'https://foresightsafety-bench.beijing-aisi.ac.cn/' },
        { name: t("services"), href: '/services' },
        // { name: t("clawaudit"), href: '/clawaudit' },
        { name: t("departments"), href: '/departments' },
        { name: t("people"), href: '/people' },
        { name: t("about"), href: '/about' },
    ]

    const ethicsSubItems = [
        { name: t("ethics_committee_committee"), href: '/articles/ai-ethics-committee-and-review-center-established#committee' },
        { name: t("ethics_committee_center"), href: '/articles/ai-ethics-committee-and-review-center-established#center' },
        { name: t("ethics_committee_research"), href: '/articles/ai-ethics-committee-and-review-center-established#research' },
    ]

    return (
        <header className="absolute inset-x-0 top-0 z-50">
            <nav className="flex items-center justify-between p-6 xl:px-8" aria-label="Global">
                <div className="flex flex-1">
                    <a href="/" className="-m-1.5">
                        <span className="sr-only">{t("project_name_short")}</span>
                        <img
                            className="h-8 w-auto bg-white rounded-full p-[2px] inline mr-3 object-contain shrink-0"
                            src={process.env.PUBLIC_URL + `/logo/red_logo_without_bg_with_text.png`}
                            alt="logo"
                        />
                        {/*<span className={`text-[16px] font-medium leading-6 text-[#c00000] ${isChinese ? 'tracking-wide' : 'tracking-wide'}`}>{t("project_name_short", {ns: 'common'})}</span>*/}
                    </a>
                </div>
                <div className="flex xl:hidden">
                    <button
                        type="button"
                        className={`-m-2.5 inline-flex items-center justify-center rounded-md p-2.5  ${isLightBg ? 'text-[#c00000]/70 hover:text-[#c00000]' : 'text-gray-100/80 hover:text-gray-100'} cursor-pointer`}
                        onClick={() => setMobileMenuOpen(true)}
                    >
                        <span className="sr-only">Open main menu</span>
                        <Bars3Icon className="h-6 w-6" aria-hidden="true" />
                    </button>
                </div>
                <div className="hidden xl:flex xl:gap-x-4">
                    {navigation.slice(0, 3).map((item) => (
                        <a key={item.name} href={item.href} className={`text-[16px] font-medium leading-6 ${isLightBg ? 'text-[#c00000]/70 hover:text-[#c00000]' : 'text-gray-100/80 hover:text-gray-100'}  ${isChinese ? 'tracking-widest' : 'tracking-wide'} cursor-pointer`}>
                            {item.name}
                        </a>
                    ))}
                    {/* 人工智能科技伦理委员会下拉菜单 */}
                    <div 
                        className="relative"
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                    >
                        <button 
                            className={`flex items-center gap-1 text-[16px] font-medium leading-6 ${isLightBg ? 'text-[#c00000]/70 hover:text-[#c00000]' : 'text-gray-100/80 hover:text-gray-100'}  ${isChinese ? 'tracking-widest' : 'tracking-wide'} cursor-pointer`}
                        >
                            {t("ethics_committee")}
                            <ChevronDownIcon className={`h-4 w-4 transition-transform ${ethicsDropdownOpen ? 'rotate-180' : ''}`} />
                        </button>
                        {ethicsDropdownOpen && (
                            <div 
                                className="absolute top-full left-0 pt-2"
                                onMouseEnter={handleMouseEnter}
                                onMouseLeave={handleMouseLeave}
                            >
                                <div className="w-48 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 py-1">
                                    {ethicsSubItems.map((item) => (
                                        <a
                                            key={item.name}
                                            href={item.href}
                                            className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-[#c00000]"
                                        >
                                            {item.name}
                                        </a>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                    {navigation.slice(3).map((item) => (
                        <a key={item.name} href={item.href} className={`text-[16px] font-medium leading-6 ${isLightBg ? 'text-[#c00000]/70 hover:text-[#c00000]' : 'text-gray-100/80 hover:text-gray-100'}  ${isChinese ? 'tracking-widest' : 'tracking-wide'} cursor-pointer`}>
                            {item.name}
                        </a>
                    ))}
                    {i18n.resolvedLanguage === "zh" &&
                        <a onClick={() => i18n.changeLanguage("en")} className={`text-[16px] font-medium leading-6 ${isLightBg ? 'text-[#c00000]/70 hover:text-[#c00000]' : 'text-gray-100/80 hover:text-gray-100'} cursor-pointer`}>English</a>
                    }
                    {i18n.resolvedLanguage === "en" &&
                        <a onClick={() => i18n.changeLanguage("zh")} className={`text-[16px] font-medium leading-6 ${isLightBg ? 'text-[#c00000]/70 hover:text-[#c00000]' : 'text-gray-100/80 hover:text-gray-100'} cursor-pointer`}>中文</a>
                    }
                </div>
                <div className="hidden xl:flex xl:flex-1 xl:justify-end">
                    {/*                    <a href="#" className="text-sm font-semibold leading-6 text-gray-900">
                        Log in <span aria-hidden="true">&rarr;</span>
                    </a>*/}
                </div>
            </nav>
            <Dialog as="div" className="xl:hidden" open={mobileMenuOpen} onClose={setMobileMenuOpen}>
                <div className="fixed inset-0 z-50" />
                <Dialog.Panel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10 bg-cover bg-black/10 bg-blend-multiply bg-bottom bg-no-repeat "
                    style={{ backgroundImage: `url(${isLightBg ? heroBackgroundImageLight : heroBackgroundImageDark})` }}
                >
                    <div className="flex items-center justify-between">
                        <a href="/" className="-m-1.5 p-1.5">
                            <span className="sr-only">北京前瞻人工智能安全与治理研究院</span>
                            <img
                                className="h-8 w-auto bg-white rounded-full p-[2px] inline mr-3"
                                src={process.env.PUBLIC_URL + `/logo/red_logo_without_bg_with_text.png`}
                                alt="logo"
                            />
                            {/*<span className={`text-[16px] font-medium leading-6 text-[#c00000] ${isChinese ? 'tracking-wide' : 'tracking-wide'}`}>{t("project_name_short", {ns: 'common'})}</span>*/}
                        </a>
                        <button
                            type="button"
                            className={`-m-2.5 rounded-md p-2.5 ${isLightBg ? 'text-[#c00000]/70 hover:text-[#c00000]' : 'text-gray-100/80 hover:text-gray-100'}`}
                            onClick={() => setMobileMenuOpen(false)}
                        >
                            <span className="sr-only">Close menu</span>
                            <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                        </button>
                    </div>
                    <div className="mt-6 flow-root">
                        <div className="-my-6 divide-y divide-gray-500/10">
                            <div className="space-y-2 py-6">
                                {navigation.map((item) => (
                                    <a
                                        key={item.name}
                                        href={item.href}
                                        className={`-mx-3 block rounded-lg px-3 py-2 text-[16px] font-medium leading-6 ${isLightBg ? 'text-[#c00000]/70 hover:text-[#c00000]' : 'text-gray-100/80 hover:text-gray-100'} cursor-pointer`}
                                        onClick={() => setMobileMenuOpen(false)}
                                    >
                                        {item.name}
                                    </a>
                                ))}
                                {/* 移动端人工智能科技伦理委员会下拉菜单 */}
                                <div className="-mx-3">
                                    <button
                                        className={`flex w-full items-center justify-between rounded-lg px-3 py-2 text-[16px] font-medium leading-6 ${isLightBg ? 'text-[#c00000]/70 hover:text-[#c00000]' : 'text-gray-100/80 hover:text-gray-100'} cursor-pointer`}
                                        onClick={() => setMobileEthicsExpanded(!mobileEthicsExpanded)}
                                    >
                                        {t("ethics_committee")}
                                        <ChevronDownIcon className={`h-4 w-4 transition-transform ${mobileEthicsExpanded ? 'rotate-180' : ''}`} />
                                    </button>
                                    {mobileEthicsExpanded && (
                                        <div className="ml-4 mt-1 space-y-1">
                                            {ethicsSubItems.map((item) => (
                                                <a
                                                    key={item.name}
                                                    href={item.href}
                                                    className={`-mx-3 block rounded-lg px-3 py-2 text-[14px] font-medium leading-6 ${isLightBg ? 'text-[#c00000]/60 hover:text-[#c00000]' : 'text-gray-100/70 hover:text-gray-100'} cursor-pointer`}
                                                    onClick={() => setMobileMenuOpen(false)}
                                                >
                                                    {item.name}
                                                </a>
                                            ))}
                                        </div>
                                    )}
                                </div>
                                {i18n.resolvedLanguage === "zh" &&
                                    <a onClick={() => {
                                        i18n.changeLanguage("en");
                                        setMobileMenuOpen(false);
                                    }}
                                        className={`-mx-3 block rounded-lg px-3 py-2 text-[16px] font-medium leading-6 ${isLightBg ? 'text-[#c00000]/70 hover:text-[#c00000]' : 'text-gray-100/80 hover:text-gray-100'} cursor-pointer`}>English</a>
                                }
                                {i18n.resolvedLanguage === "en" &&
                                    <a onClick={() => {
                                        i18n.changeLanguage("zh");
                                        setMobileMenuOpen(false);
                                    }}
                                        className={`-mx-3 block rounded-lg px-3 py-2 text-[16px] font-medium leading-6 ${isLightBg ? 'text-[#c00000]/70 hover:text-[#c00000]' : 'text-gray-100/80 hover:text-gray-100'} cursor-pointer`}>中文</a>
                                }
                            </div>
                            {/*                            <div className="py-6">
                                <a
                                    href="#"
                                    className="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7 text-gray-900 hover:bg-white/5"
                                >
                                    Log in
                                </a>
                            </div>*/}
                        </div>
                    </div>
                </Dialog.Panel>
            </Dialog>
        </header>
    )
}

export default Navbar;